import { defineMessages } from 'react-intl';

export default defineMessages({
  'heading': {
    'id': 'not_found.heading',
    'defaultMessage': '404',
    'description': 'Not found page heading and title'
  },
  'intro': {
    'id': 'not_found.intro',
    'defaultMessage': 'The page you were looking for appears to have been moved, deleted or does not exist.',
    'description': 'Not found page heading intro'
  },
  'go_home_label': {
    'id': 'not_found.go_home_label',
    'defaultMessage': 'Go Home',
    'description': 'Go home button text'
  }
});



// WEBPACK FOOTER //
// ./src/client/pages/errors/messages.js